import { regionContent } from "@kursk/content/regionContent";

const messengers = ['max', 'telegram'];

export const checkSocials = () => {
  if (!regionContent.socials.vk) return false;

  return Object.entries(regionContent.socials).some(([key, value]) => {
    return messengers.includes(key) && value;
  });
}
